import { createContext, useContext, type ReactNode } from 'react';
import { usePublicClinic } from '@leoclinic/hooks';
import type { PublicClinicView } from '@leoclinic/types';
import { CLINIC_SLUG } from '@/config/clinic.config';
import { useClinicDocumentMeta } from '@/hooks/use-clinic-document-meta';

interface ClinicContextValue {
  clinic: PublicClinicView | null;
  clinicId: string | null;
  isLoading: boolean;
  slug: string;
}

const ClinicContext = createContext<ClinicContextValue>({
  clinic: null,
  clinicId: null,
  isLoading: true,
  slug: CLINIC_SLUG,
});

export function ClinicProvider({ children }: { children: ReactNode }) {
  const { data: clinic, isLoading } = usePublicClinic(CLINIC_SLUG);
  useClinicDocumentMeta(clinic ?? null);

  return (
    <ClinicContext.Provider
      value={{
        clinic: clinic ?? null,
        clinicId: clinic?.id ?? null,
        isLoading,
        slug: CLINIC_SLUG,
      }}
    >
      {children}
    </ClinicContext.Provider>
  );
}

export function useClinicPortal() {
  return useContext(ClinicContext);
}
